/**
 * Zenith Digital CRP Application Metadata
 * Follows Semantic Versioning (SemVer 2.0.0): MAJOR.MINOR.PATCH
 * 
 * Rules for version increments:
 * - MAJOR (1.x.x): Incompatible API changes, major architectural refactoring, or full rebranding.
 * - MINOR (x.1.x): Backwards-compatible new features, modules, or significant capabilities.
 * - PATCH (x.x.1): Backwards-compatible bug fixes, minor UI polish, or performance tweaks.
 */
export const APP_INFO = {
  name: "Zenith Digital CRP",
  shortName: "Zenith Digital",
  subtitle: "CRP",
  version: "1.0.0",
  versionBadge: "v1.0.0",
  releaseDate: "2026-08-14",
  environment: process.env.NODE_ENV || "development",
  author: "Zenith Digital",
  copyright: "© 2026 Zenith Digital CRP. Barcha huquqlar himoyalangan."
} as const;

export default APP_INFO;
